import { render, staticRenderFns } from "./UserSection.vue?vue&type=template&id=fe014000&scoped=true&"
import script from "./UserSection.vue?vue&type=script&lang=js&"
export * from "./UserSection.vue?vue&type=script&lang=js&"
import style0 from "./UserSection.vue?vue&type=style&index=0&id=fe014000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe014000",
  null
  
)

export default component.exports